import { Component, OnInit, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputFieldComponent } from 'src/app/shared/component/input-field/input-field.component';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ContactUsMessagesFilter } from 'src/app/shared/interfaces';
import { takeUntil } from 'rxjs/operators';
import { BaseFilterComponent } from 'src/app/shared/component/base-filter-component/base-filter-component';
import { FiltersContainerComponent } from 'src/app/shared/component/filters-container/filters-container.component';
import { DateRangeComponent } from 'src/app/shared/component/date-range/date-range.component';

@Component({
  selector: 'app-contact-us-messages-filters',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    InputFieldComponent,
    DateRangeComponent,
    FiltersContainerComponent
  ],
  templateUrl: './contact-us-messages-filters.component.html',
  styleUrls: ['./contact-us-messages-filters.component.scss'],
})
export class ContactUsMessagesFiltersComponent extends BaseFilterComponent<ContactUsMessagesFilter> implements OnInit {
 
  constructor(injector: Injector) {
    super([], injector);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  protected initializeForm(): void {
    this.form = new FormGroup({
      userName: new FormControl(),
      name: new FormControl(),
      email: new FormControl(),
      dateRange: new FormControl(),
    });
  }
}
